import { jarallax, jarallaxVideo } from 'jarallax';
import init from '../../../js/init';

const name = 'hero';
const selector = '.hero';
const jarallaxSelector = `${selector}__jarallax`;
const imgSelector = `${selector}__image-wrapper img`;

init(Drupal, name, selector, root => {
  const videoUrl = root.getAttribute('data-video');
  if (!videoUrl) return;

  const jarallaxElem = root.querySelector(jarallaxSelector);

  jarallaxVideo();
  jarallax(jarallaxElem, {
    speed: 0,
    videoSrc: videoUrl,
    imgElement: imgSelector,
  });
});
